module.exports = __webpack_public_path__ + "img/small.0c58eff1.jpg";